import React, { useContext } from "react";
import PropTypes from "prop-types";
import { AppContext } from "../../../context/AppContext";
import Avatar from "../../../assets/images/Avatar.png";

const Lecture = (props) => {
  const { firstName } = useContext(AppContext);
  const { data = {}, Color = [{}], Lectures = {} } = props;
  const base_url = "https://app.edsys.in:3000/";

  // Safely access nested properties
  const bgColor = Color?.[0]?.bgColor || "";
  const imageSrc = data?.Image ? `${base_url}${data.Image}` : Avatar;
  const subject = data?.Subject;
  const teacherName = data?.teacher_name;
  const className = data?.class_name;
  const division = data?.Division;
  const lectureClassName = Lectures?.class_name;
  const lectureDivisionName = Lectures?.class_division_name;

  // Determine what to display based on conditions
  const getDisplayContent = () => {
    if (subject === "No Duty" || subject === "Not Scheduled") {
      return "-";
    }

    if (firstName === teacherName) {
      if (className && division) {
        return `${className}-${division}`;
      }
      if (lectureClassName && lectureDivisionName) {
        return `${lectureClassName}-${lectureDivisionName}`;
      }
    }

    return subject || teacherName || "No Duty";
  };

  return (
    <div className={`tt-col tt-content ${bgColor}`}>
      <div className="tt-desc tt-desc-inner">
        <img
          src={imageSrc}
          alt="Lecture"
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = Avatar;
          }}
        />
        <div className="title">{getDisplayContent()}</div>
        <div className="duration">
          <p className="status">{subject || "No Duty"}</p>
        </div>
      </div>
    </div>
  );
};

Lecture.propTypes = {
  data: PropTypes.shape({
    Image: PropTypes.string,
    Subject: PropTypes.string,
    teacher_name: PropTypes.string,
    class_name: PropTypes.string,
    Division: PropTypes.string,
  }),
  Color: PropTypes.arrayOf(
    PropTypes.shape({
      bgColor: PropTypes.string,
    })
  ),
  Lectures: PropTypes.shape({
    class_name: PropTypes.string,
    class_division_name: PropTypes.string,
  }),
};

Lecture.defaultProps = {
  data: {},
  Color: [{}],
  Lectures: {},
};

export default Lecture;
